import React from "react";
import "./Moving_with_a_lifting_crane.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Moving_with_a_lifting_crane() {

  const seo = {
    title:
      "הובלות עם מנוף הרמה | הובלה והרמה עם מנוף | ש.מ הובלות ומנופים",
    description:
      "שירותי הובלות עם מנוף הרמה לחומרי בניין, עצים, ציוד כבד, מכולות וגנרטורים תעשייתיים. ש.מ הובלות ומנופים מספקת פתרונות הובלה והרמה לקבלנים, חברות, עסקים ולקוחות פרטיים ברחבי הארץ.",
    url:
      "https://smtovala.co.il/Moving_with_a_lifting_crane",
    image:
      "https://smtovala.co.il/images/32.jpeg"
  };

  const items = [
    {
      title: "הובלת חומרי בניין",
      img: "/images/9.jpeg",
      path: "/Transportation_of_building_materials",
    },
    {
      title: "הובלת עצים",
      img: "/images/31.jpeg",
      path: "/Transporting_wood",
    },
    {
      title: "הובלת ציוד כבד",
      img: "/images/32.jpeg",
      path: "/Transporting_heavy_equipment",
    },
    {
      title: "הובלת מכולות",
      img: "/images/33.png",
      path: "/Container_Transportation",
    },
    {
      title: "הובלת גנרטורים תעשייתיים",
      img: "/images/12.png",
      path: "/Transportation_of_industrial_and_heavy_generators",
    },
  ];

  return (
    <div className="Moving_with_a_lifting_crane-page">

      {/* =====================================================
          SEO
      ===================================================== */}

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        {/* Open Graph */}

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        {/* Twitter */}

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="Moving_with_a_lifting_crane-hero">

        <div className="Moving_with_a_lifting_crane-overlay">

          <h1>הובלות עם מנוף הרמה</h1>

        </div>

      </div>


      {/* =====================================================
          SERVICES
      ===================================================== */}

      <div className="page2">

        <div className="grid3">

          {items.map((item, index) => (

            <Link
              to={item.path}
              key={index}
              className="card3"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "instant",
                });
              }}
            >

              <img
                src={item.img}
                alt={item.title}
              />

              <div className="card3-btn">
                {item.title}
              </div>

            </Link>

          ))}

        </div>

      </div>

    </div>
  );
}
